import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { getItem, setItem, StorageItem } from '@utils/local-storage.tool';

@Injectable({
	providedIn: 'root',
})
export class PresenterModeService {
	applyIncognito: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor() {
		this.updateMode();
	}

	setMode(applyIncognito: boolean): void {
		setItem(StorageItem.INCOGNITO_MODE, `${applyIncognito}`);
		window.dispatchEvent(
			new StorageEvent('storage', { key: StorageItem.INCOGNITO_MODE, newValue: String(applyIncognito) }),
		);
		this.applyIncognito.next(applyIncognito);
	}

	getMode(): boolean {
		return this.applyIncognito.getValue();
	}

	toggleMode(): void {
		const currentMode = this.getMode();
		this.setMode(!currentMode);
	}

	private updateMode(): void {
		const currentValue = getItem(StorageItem.INCOGNITO_MODE) as string;
		if (currentValue === 'true') {
			this.applyIncognito.next(true);
			return;
		}
		this.applyIncognito.next(false);
	}
}
